import React, { useRef, useState } from 'react';

type StateUpdateFunction<T> = (prevState: T) => T;
type StateUpdater<T> = T | StateUpdateFunction<T>;

const useRefState = <T>(defaultValue: T): [T, (v: StateUpdater<T>) => void, React.RefObject<T>] => {
    const [state, setState] = useState<T>(defaultValue);
    const stateRef = useRef<T>(defaultValue);

    const handleStateChange = (value: StateUpdater<T>) => {
        if (typeof value === 'function') {
            setState((prevState) => {
                const newState = (value as StateUpdateFunction<T>)(prevState);
                stateRef.current = newState;
                return newState;
            });
        } else {
            setState(value);
            stateRef.current = value;
        }
    };

    return [state, handleStateChange, stateRef];
};

export default useRefState;
